import { useCallback, useContext, useEffect, useState } from 'react';

import {
  ColSize,
  RowSize,
} from '../../../../../../../../../../../shared/components';
import { FormCoverages } from './components/Form';
import { Tabs } from '@hdi-seguros/web-components.tabs';

import { StepFourFormContext } from '../../../../../StepFour/contexts/StepFourForm';

export const PropertyDataSection = () => {
  const { fireQuotationComponents } = useContext(StepFourFormContext);

  const [activeTab, setActiveTab] = useState<any>(
    fireQuotationComponents[0].nroComponente
  );
  const [tabs, setTabs] = useState<Array<any>>([]);

  const createTabs = useCallback(() => {
    const newTabs = fireQuotationComponents.map((fireComponent) => ({
      children: <FormCoverages fireComponent={fireComponent} />,
      closable: false,
      forceRender: true,
      key: fireComponent.nroComponente,
      label: `Incendio Web ${fireComponent.nroComponente}`,
    }));

    setTabs(newTabs);
  }, [fireQuotationComponents, setTabs]);

  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  useEffect(() => {
    createTabs();
  }, [createTabs]);

  return (
    <RowSize className='mt-1'>
      <ColSize size={100}>
        <Tabs
          activeKey={activeTab}
          handlePressTab={handlePressTab}
          items={tabs}
        />
      </ColSize>
    </RowSize>
  );
};
